export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Pages', route: 'pages', type: 'page', shortcut: 'page/_' },
                { name: 'Panel library', route: 'panels', type: 'panel', shortcut: 'panel/_' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
        },
        {
            name: 'News',
            route: 'news_posts',
            type: 'news_post',
            // children: [
            //     { name: 'Posts', route: 'news_posts', type: 'news_post' },
            //     { name: 'Categories', route: 'news_categories', type: 'news_category' },
            // ],
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
        },
        {
            name: 'Videos',
            route: 'videos',
            type: 'video',
            iconClass: 'material-icons',
            iconName: 'video_library',
            color: 'navy',
        },
        {
            name: 'FAQs',
            route: 'faqs',
            type: 'faq',
            iconClass: 'material-icons',
            iconName: 'help_outline',
            color: 'navy',
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Brands', route: 'brands', type: 'brand' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        {
            name: 'Projects',
            route: 'projects',
            type: 'project',
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
        },
        {
            name: 'Stockists',
            type: 'stockist',
            route: 'stockists',
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        // {
        //     name: 'Customers',
        //     type: 'customer',
        //     route: 'customers',
        //     iconClass: 'material-icons',
        //     iconName: 'perm_contact_calendar',
        //     color: 'navy',
        // },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', shortcut: 'user/_', type: 'user' },
                { name: 'Roles', route: 'roles', shortcut: 'role/_', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        },
    ],
    defaultItem: 'Content',
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js